import { GlBadge, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { issuableTypeText } from '~/issues/constants';
import { __, sprintf } from '~/locale';
export default {
    name: 'LockedBadge',
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        issuableType: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        title () {
            return sprintf(__('The discussion in this %{issuable} is locked. Only project members can comment.'), {
                issuable: issuableTypeText[this.issuableType]
            });
        }
    }
};
